/** Auto-generated gallery mesh inventory — do not hand-edit */
/** Generated from public/assets/patterns/templates/meshes/GalleryScene_*.babylon */

export const GALLERY_PRINT_MESHES: Record<number, string[]> = {
  400: ['template_Shape_001'],
  401: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006'],
  402: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006', 'template_Shape_007', 'template_Shape_008', 'template_Shape_009', 'template_Shape_010', 'template_Shape_011', 'template_Shape_012', 'template_Shape_013', 'template_Shape_014', 'template_Shape_015', 'template_Shape_016', 'template_Shape_017', 'template_Shape_018'],
  403: ['template_Shape_01', 'template_Shape_02', 'template_Shape_03', 'template_Shape_04', 'template_Shape_05'],
  404: ['template_Shape_01'],
  405: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006'],
  406: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006', 'template_Shape_007', 'template_Shape_008', 'template_Shape_009', 'template_Shape_010', 'template_Shape_011', 'template_Shape_012', 'template_Shape_013', 'template_Shape_014', 'template_Shape_015', 'template_Shape_016', 'template_Shape_017', 'template_Shape_018'],
  407: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005'],
  408: ['template_Shape_01'],
  409: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006'],
  410: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006', 'template_Shape_007', 'template_Shape_008', 'template_Shape_009', 'template_Shape_010', 'template_Shape_011', 'template_Shape_012', 'template_Shape_013', 'template_Shape_014', 'template_Shape_015', 'template_Shape_016', 'template_Shape_017', 'template_Shape_018'],
  411: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005'],
  412: ['template_Shape_01'],
  413: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006'],
  414: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006', 'template_Shape_007', 'template_Shape_008', 'template_Shape_009', 'template_Shape_010', 'template_Shape_011', 'template_Shape_012', 'template_Shape_013', 'template_Shape_014', 'template_Shape_015', 'template_Shape_016', 'template_Shape_017', 'template_Shape_018'],
  415: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005'],
  416: ['template_Shape_01'],
  417: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006'],
  418: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006', 'template_Shape_007', 'template_Shape_008', 'template_Shape_009', 'template_Shape_010', 'template_Shape_011', 'template_Shape_012', 'template_Shape_013', 'template_Shape_014', 'template_Shape_015', 'template_Shape_016', 'template_Shape_017', 'template_Shape_018'],
  419: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005'],
  420: ['template_Shape_01'],
  421: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006'],
  422: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006', 'template_Shape_007', 'template_Shape_008', 'template_Shape_009', 'template_Shape_010', 'template_Shape_011', 'template_Shape_012', 'template_Shape_013', 'template_Shape_014', 'template_Shape_015', 'template_Shape_016', 'template_Shape_017', 'template_Shape_018'],
  423: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005'],
  424: ['template_Shape_01'],
  425: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006'],
  426: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006', 'template_Shape_007', 'template_Shape_008', 'template_Shape_009', 'template_Shape_010', 'template_Shape_011', 'template_Shape_012', 'template_Shape_013', 'template_Shape_014', 'template_Shape_015', 'template_Shape_016', 'template_Shape_017', 'template_Shape_018'],
  427: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006'],
  428: ['template_Shape_01'],
  429: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006'],
  430: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006', 'template_Shape_007', 'template_Shape_008', 'template_Shape_009', 'template_Shape_010', 'template_Shape_011', 'template_Shape_012', 'template_Shape_013', 'template_Shape_014', 'template_Shape_015', 'template_Shape_016', 'template_Shape_017', 'template_Shape_018'],
  431: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005'],
  432: ['template_Shape_01'],
  433: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006'],
  434: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006', 'template_Shape_007', 'template_Shape_008', 'template_Shape_009', 'template_Shape_010', 'template_Shape_011', 'template_Shape_012', 'template_Shape_013', 'template_Shape_014', 'template_Shape_015', 'template_Shape_016', 'template_Shape_017', 'template_Shape_018'],
  435: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006'],
  436: ['template_Shape_01'],
  437: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006'],
  438: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006', 'template_Shape_007', 'template_Shape_008', 'template_Shape_009', 'template_Shape_010', 'template_Shape_011', 'template_Shape_012', 'template_Shape_013', 'template_Shape_014', 'template_Shape_015', 'template_Shape_016', 'template_Shape_017', 'template_Shape_018'],
  439: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005'],
  440: ['template_Shape_01'],
  441: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006'],
  442: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006', 'template_Shape_007', 'template_Shape_008', 'template_Shape_009', 'template_Shape_010', 'template_Shape_011', 'template_Shape_012', 'template_Shape_013', 'template_Shape_014', 'template_Shape_015', 'template_Shape_016', 'template_Shape_017', 'template_Shape_018'],
  443: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003'],
  444: ['template_Shape_01'],
  445: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006'],
  446: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006', 'template_Shape_007', 'template_Shape_008', 'template_Shape_009', 'template_Shape_010', 'template_Shape_011', 'template_Shape_012', 'template_Shape_013', 'template_Shape_014', 'template_Shape_015', 'template_Shape_016', 'template_Shape_017', 'template_Shape_018'],
  447: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003'],
  448: ['template_Shape_01'],
  449: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006'],
  450: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006', 'template_Shape_007', 'template_Shape_008', 'template_Shape_009', 'template_Shape_010', 'template_Shape_011', 'template_Shape_012', 'template_Shape_013', 'template_Shape_014', 'template_Shape_015', 'template_Shape_016', 'template_Shape_017', 'template_Shape_018'],
  451: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003'],
  452: ['template_Shape_01'],
  453: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006'],
  454: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003', 'template_Shape_004', 'template_Shape_005', 'template_Shape_006', 'template_Shape_007', 'template_Shape_008', 'template_Shape_009', 'template_Shape_010', 'template_Shape_011', 'template_Shape_012', 'template_Shape_013', 'template_Shape_014', 'template_Shape_015', 'template_Shape_016', 'template_Shape_017', 'template_Shape_018'],
  455: ['template_Shape_001', 'template_Shape_002', 'template_Shape_003'],
}

export const GALLERY_WALL_MESHES: Record<number, string[]> = {
  400: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  401: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  402: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  403: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  404: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  405: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  406: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  407: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  408: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  409: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  410: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  411: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  412: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004'],
  413: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004'],
  414: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004'],
  415: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004'],
  416: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004'],
  417: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004'],
  418: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004'],
  419: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004'],
  420: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  421: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  422: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  423: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  424: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_005'],
  425: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_005'],
  426: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_005', 'Scene_Wall_006', 'Scene_Wall_007'],
  427: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_005', 'Scene_Wall_006', 'Scene_Wall_007'],
  428: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004'],
  429: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004'],
  430: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004'],
  431: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004'],
  432: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004', 'Scene_Wall_005', 'Scene_Wall_006'],
  433: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004', 'Scene_Wall_005', 'Scene_Wall_006'],
  434: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004', 'Scene_Wall_005', 'Scene_Wall_006', 'Scene_Wall_007', 'Scene_Wall_008'],
  435: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004', 'Scene_Wall_005', 'Scene_Wall_006', 'Scene_Wall_007', 'Scene_Wall_008'],
  436: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  437: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  438: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  439: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003'],
  440: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004', 'Scene_Wall_005', 'Scene_Wall_006'],
  441: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004', 'Scene_Wall_005', 'Scene_Wall_006'],
  442: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004', 'Scene_Wall_005', 'Scene_Wall_006'],
  443: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004', 'Scene_Wall_005', 'Scene_Wall_006'],
  444: ['Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004', 'Scene_Wall_007'],
  445: ['Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004', 'Scene_Wall_007'],
  446: ['Scene_Wall_002.001', 'Scene_Wall_003', 'Scene_Wall_004.001', 'Scene_Wall_007', 'Scene_Wall_012', 'Scene_Wall_013'],
  447: ['Scene_Wall_002.001', 'Scene_Wall_003', 'Scene_Wall_004.001', 'Scene_Wall_007', 'Scene_Wall_012', 'Scene_Wall_013'],
  448: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004'],
  449: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004'],
  450: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004', 'Scene_Wall_005', 'Scene_Wall_006'],
  451: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004', 'Scene_Wall_005', 'Scene_Wall_006'],
  452: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004', 'Scene_Wall_005'],
  453: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004', 'Scene_Wall_005'],
  454: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004', 'Scene_Wall_005'],
  455: ['Scene_Wall_001', 'Scene_Wall_002', 'Scene_Wall_003', 'Scene_Wall_004', 'Scene_Wall_005'],
}

export const GALLERY_FLOOR_MESHES: Record<number, string[]> = {
  400: ['Scene_Floor_001'],
  401: ['Scene_Floor_001'],
  402: ['Scene_Floor_001'],
  403: ['Scene_Floor_001'],
  404: ['Scene_Floor_001'],
  405: ['Scene_Floor_001'],
  406: ['Scene_Floor_001'],
  407: ['Scene_Floor_001'],
  408: ['Scene_Floor_001'],
  409: ['Scene_Floor_001'],
  410: ['Scene_Floor_001'],
  411: ['Scene_Floor_001'],
  412: ['Scene_Floor_001'],
  413: ['Scene_Floor_001'],
  414: ['Scene_Floor_001'],
  415: ['Scene_Floor_001'],
  416: ['Scene_Floor_001'],
  417: ['Scene_Floor_001'],
  418: ['Scene_Floor_002'],
  419: ['Scene_Floor_002'],
  420: ['Scene_Floor_001'],
  421: ['Scene_Floor_001'],
  422: ['Scene_Floor_001'],
  423: ['Scene_Floor_001'],
  424: ['Scene_Floor_001'],
  425: ['Scene_Floor_001'],
  426: ['Scene_Floor_001'],
  427: ['Scene_Floor_001'],
  428: ['Scene_Floor_001'],
  429: ['Scene_Floor_001'],
  430: ['Scene_Floor_001'],
  431: ['Scene_Floor_001'],
  432: ['Scene_Floor_001'],
  433: ['Scene_Floor_001'],
  434: ['Scene_Floor_001'],
  435: ['Scene_Floor_001'],
  436: ['Scene_Floor_001'],
  437: ['Scene_Floor_001'],
  438: ['Scene_Floor_001'],
  439: ['Scene_Floor_001'],
  440: ['Scene_Floor_001'],
  441: ['Scene_Floor_001'],
  442: ['Scene_Floor_001'],
  443: ['Scene_Floor_001'],
  444: ['Scene_Floor_001'],
  445: ['Scene_Floor_001'],
  446: ['Scene_Floor_001'],
  447: ['Scene_Floor_001'],
  448: ['Scene_Floor_001'],
  449: ['Scene_Floor_001'],
  450: ['Scene_Floor_001'],
  451: ['Scene_Floor_001'],
  452: ['Scene_Floor_001'],
  453: ['Scene_Floor_001'],
  454: ['Scene_Floor_001'],
  455: ['Scene_Floor_001'],
}

export const GALLERY_CEIL_MESHES: Record<number, string[]> = {
  400: ['Scene_Ceiling_001'],
  401: ['Scene_Ceiling_001'],
  402: ['Scene_Ceiling_001'],
  403: ['Scene_Ceiling_001'],
  404: ['Scene_Ceiling_001'],
  405: ['Scene_Ceiling_001'],
  406: ['Scene_Ceiling_001'],
  407: ['Scene_Ceiling_001'],
  408: ['Scene_Ceiling_001'],
  409: ['Scene_Ceiling_001'],
  410: ['Scene_Ceiling_001'],
  411: ['Scene_Ceiling_001'],
  412: ['Scene_Ceiling_001'],
  413: ['Scene_Ceiling_001'],
  414: ['Scene_Ceiling_001'],
  415: ['Scene_Ceiling_001'],
  416: ['Scene_Ceiling_001'],
  417: ['Scene_Ceiling_001'],
  418: ['Scene_Ceiling_001'],
  419: ['Scene_Ceiling_001'],
  420: ['Scene_Ceiling_001'],
  421: ['Scene_Ceiling_001'],
  422: ['Scene_Ceiling_001'],
  423: ['Scene_Ceiling_001'],
  424: ['Scene_Ceiling_001'],
  425: ['Scene_Ceiling_001'],
  426: ['Scene_Ceiling_001'],
  427: ['Scene_Ceiling_001'],
  428: ['Scene_Ceiling_001'],
  429: ['Scene_Ceiling_001'],
  430: ['Scene_Ceiling_001'],
  431: ['Scene_Ceiling_001'],
  432: ['Scene_Ceiling_001', 'Scene_Ceiling_002'],
  433: ['Scene_Ceiling_001', 'Scene_Ceiling_002'],
  434: ['Scene_Ceiling_002', 'Scene_Ceiling_001'],
  435: ['Scene_Ceiling_002', 'Scene_Ceiling_001'],
  436: ['Scene_Ceiling_001'],
  437: ['Scene_Ceiling_001'],
  438: ['Scene_Ceiling_001'],
  439: ['Scene_Ceiling_001'],
  440: ['Scene_Ceiling_001'],
  441: ['Scene_Ceiling_001'],
  442: ['Scene_Ceiling_001'],
  443: ['Scene_Ceiling_001'],
  444: ['Scene_Ceiling_001'],
  445: ['Scene_Ceiling_001'],
  446: ['Scene_Ceiling_001'],
  447: ['Scene_Ceiling_001'],
  448: ['Scene_Ceiling_001'],
  449: ['Scene_Ceiling_001'],
  450: ['Scene_Ceiling_001'],
  451: ['Scene_Ceiling_001'],
  452: ['Scene_Ceiling_001'],
  453: ['Scene_Ceiling_001'],
  454: ['Scene_Ceiling_001'],
  455: ['Scene_Ceiling_001'],
}

export function getGalleryPrintMeshes(templateId: number | string | undefined): string[] {
  if (templateId == null) return GALLERY_PRINT_MESHES[400] || []
  const id = Number(templateId)
  return GALLERY_PRINT_MESHES[id] || GALLERY_PRINT_MESHES[400] || []
}

export function getGalleryWallMeshes(templateId: number | string | undefined): string[] {
  if (templateId == null) return GALLERY_WALL_MESHES[400] || []
  const id = Number(templateId)
  return GALLERY_WALL_MESHES[id] || GALLERY_WALL_MESHES[400] || []
}

export function getGalleryFloorMeshes(templateId: number | string | undefined): string[] {
  if (templateId == null) return GALLERY_FLOOR_MESHES[400] || []
  const id = Number(templateId)
  return GALLERY_FLOOR_MESHES[id] || GALLERY_FLOOR_MESHES[400] || []
}

export function getGalleryCeilMeshes(templateId: number | string | undefined): string[] {
  if (templateId == null) return GALLERY_CEIL_MESHES[400] || []
  const id = Number(templateId)
  return GALLERY_CEIL_MESHES[id] || GALLERY_CEIL_MESHES[400] || []
}

export function getGallerySlotCount(templateId: number | string | undefined): number {
  return getGalleryPrintMeshes(templateId).length
}
